/** Карточка серии — ровно то, что отдаёт `GET /api/serials/{serial}/card`.
 *  Спека `docs/specs/2026-10-22-serial-card-design.md`. */
import { apiFetch } from "@/lib/api";

export type SborValue = { type: number; date: string | null; deal: number | null; name?: string | null };

export type SerialComment = {
  id: number;
  text: string | null;
  at: string | null;
  deal: number | null;
  who: string | null;
  previews?: string[];
  images?: string[];
};

export type SerialTask = SerialComment & {
  task: number;
  name: string;
  status: number | null;
  status_name: string | null;
  color: string | null;
  /** Задача «к следующей сделке» не той сделки, под которую собираем (`isNotNextDealTask` CRM). */
  other_deal: boolean;
};

export type SerialReserve = {
  deal: number;
  stage: string;
  stage_name: string | null;
  start: string | null;
  end: string | null;
  city: string | null;
  other_city: boolean;
  is_sale: boolean;
  is_select: boolean;
  paid: number;
  sum: number;
  days_paid: number | null;
  visit: { id: number; at: string | null; needs_serial: boolean; comment: string | null; tailor: boolean } | null;
  /** `b24Deal.visitID`: что записано в CRM и что должно быть по правилу `isNear`. */
  deal_visit: { crm: number | null; calc: number | null; ok: boolean };
  /** Под эту бронь сейчас собираем серию (`sSerial.sborDealID`). */
  sbor: boolean;
  /** Сделки, с окнами договоров которых бронь пересекается. */
  cross: number[];
};

export type SerialVisit = {
  id: number;
  deal: number | null;
  at: string | null;
  status: number;
  status_name: string | null;
  category: string | null;
  tailor: boolean;
  near: boolean;
  comment: string | null;
};

export type SerialCard = {
  serial: number;
  article: number | null;
  name: string | null;
  category: string | null;
  size: string | null;
  color: string | null;
  brand: string | null;
  available: boolean;
  photo: string | null;
  place: {
    at: string | null;
    group: string | null;
    name: string | null;
    city: string | null;
    who: string | null;
    /** Самая свежая из дат места и RFID — её показываем жирным. */
    latest: "place" | "antenna" | "terminal";
    rfid: { kind: "antenna" | "terminal"; at: string; name: string | null; city: string | null; other_city: boolean }[];
    need_rfid: boolean;
  };
  sbor: {
    crm: SborValue;
    calc: SborValue;
    next_deal: { crm: number | null; calc: number | null };
    visit: { crm: number | null; calc: number | null };
    ok: boolean;
  };
  reserves: SerialReserve[];
  visits: SerialVisit[];
  comments: { pinned: SerialComment | null; tasks: SerialTask[]; recent: SerialComment[] };
  price: {
    rent_status: number | null;
    rent: (number | null)[];
    rent_min: number | null;
    sale_status: number | null;
    sale: number | null;
    sale_min: number | null;
  };
};

export const serialCardQuery = (serial: number) => ({
  queryKey: ["serial-card", serial],
  queryFn: () => apiFetch<SerialCard>(`/api/serials/${serial}/card`),
  staleTime: 0,
});
